import Text from '@redbubble/design-system/src/Text';
import { useIntl } from '@redbubble/next/intl';
import { ShippingMethod } from '../../../types/cart/ShippingMethod';
import type { DeliveryDetail } from '../types';
import styles from './DeliveryWindow.module.scss';
import { deliveryWindowMessage } from './deliveryWindowMessage';
import { messages } from './messages';

interface DeliveryWindowFrameProps {
  shippingMethod: ShippingMethod;
  deliveryDetail: DeliveryDetail;
  flatRateApplied?: boolean;
}

const bold = (str) => <b>{str}</b>;

export const DeliveryWindow = ({
  shippingMethod,
  deliveryDetail,
  flatRateApplied,
}: DeliveryWindowFrameProps) => {
  const intl = useIntl();

  const isStandardShipping = shippingMethod === ShippingMethod.Standard;
  const standardCopy = flatRateApplied
    ? messages.flatRateShipping
    : messages.standardShipping;
  const method = intl.formatMessage(
    isStandardShipping ? standardCopy : messages.expressShipping
  );

  if (
    ![ShippingMethod.Standard, ShippingMethod.Express].includes(shippingMethod)
  ) {
    return null;
  }

  return (
    <>
      <div className={styles.shippingName}>
        <Text type="body2">
          <b>{method}</b>
        </Text>
      </div>

      <div className={styles.shippingDates}>
        <Text type="body2">
          {deliveryWindowMessage(deliveryDetail, intl, bold)}
        </Text>
      </div>
    </>
  );
};
